import { render } from "./SaveSubscriber.vue?vue&type=template&id=611cea02&scoped=true"
import script from "./SaveSubscriber.vue?vue&type=script&lang=js"
export * from "./SaveSubscriber.vue?vue&type=script&lang=js"

import "./SaveSubscriber.vue?vue&type=style&index=0&id=611cea02&scoped=true&lang=css"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611cea02"]])

export default __exports__